export default "/images/vendor/flag-icons/flags/4x3/pt.svg?10d6b7eb9f926ba44b84fe3c9a43c9cd";